import PropTypes from 'prop-types';

import * as HairTexture from 'constants/hairTextures';

const HairTexureProps = PropTypes.oneOf(Object.values(HairTexture));

export default HairTexureProps;
